
<template>
<div class="draft-canvas-con">
  <div class="main">
    <Draft
      :draftId="draftId"
       @editDraftId="editDraftId"
       @move="move"
    />
  </div>

  <!-- 流程进度触发图标 -->
  <div v-if="isFlowActive" class="flow-trigger-icon" @click="showFlowDialog = true">
    <i class="el-icon-s-operation"></i>
    <div class="icon-pulse"></div>
  </div>

  <!-- 流程进度弹窗 -->
  <ProcessFlowDialog :visible.sync="showFlowDialog" />

  <el-dialog title="登陆" :visible.sync="dialogTableVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escap="false"
    >
    <div class="login-container">
      <h3>您的好友向你推荐了一个文档，请登陆或者注册之后查看</h3>
      <LoginFrom :type="1" @loginSuccess="loginSuccess"></LoginFrom>
    </div>
  </el-dialog>
</div>

</template>

<script>
import request from '@/http/request'
import Draft from '../components/draft'
import LoginFrom from '@/views/login/index.vue'
import ProcessFlowDialog from '@/components/process-flow/ProcessFlowDialog.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      dialogTableVisible: false,
      draftId: null,
      showFlowDialog: false,
      autoProgressTimer: null
    }
  },
  components: {
    Draft,
    LoginFrom,
    ProcessFlowDialog
  },
  computed: {
    ...mapState('processFlow', ['isFlowActive', 'isRunning', 'currentStep', 'flowSteps']),
    ...mapGetters('processFlow', ['currentRunningStep'])
  },
  watch: {
    currentRunningStep (newStep) {
      if (newStep && newStep.id === 'main-graph') {
        this.startAutoProgress()
      }
    },
    
    isFlowActive (val) {
      if (val) {
        this.showFlowDialog = true
      }
    }
  },
  methods: {
    loginSuccess () {
      this.dialogTableVisible = false
    },
    editDraftId (val) {
      this.draftId = val
      this.$router.push({
        name: 'draft',
        query: {
          id: val
        }
      })
    },
    move () {
      this.draftId = this.$route.query.id
      const userinfo = JSON.parse(localStorage.getItem('userinfo'))
      if (!userinfo) {
        this.dialogTableVisible = true
      }
    },
    
    startAutoProgress () {
      if (this.autoProgressTimer) {
        clearTimeout(this.autoProgressTimer)
      }
      
      const progressNext = () => {
        if (this.currentStep >= this.flowSteps.length - 1) {
          this.stopAutoProgress()
          return
        }
        
        const currentStepId = this.flowSteps[this.currentStep].id
        
        // 检查当前步骤是否是秒记库（在推进之前检查）
        if (currentStepId === 'quick-note-library') {
          // 完成秒记库步骤
          this.$store.dispatch('processFlow/updateStepStatus', { 
            stepId: 'quick-note-library', 
            status: 'completed' 
          })
          // 暂停流程并显示询问对话框
          this.stopAutoProgress()
          this.$store.dispatch('processFlow/pauseFlow') // 暂停流程
          this.$store.dispatch('processFlow/setWaitingForBubbleJump', true) // 设置等待状态
          // 延迟显示对话框，让用户看到秒记库已完成
          setTimeout(() => {
            this.showBubbleJumpConfirm()
          }, 500)
          return
        }
        
        // 推进到下一步
        this.$store.dispatch('processFlow/nextStep')
        
        if (this.currentStep >= this.flowSteps.length - 1) {
          setTimeout(() => {
            this.$store.dispatch('processFlow/completeFlow')
          }, 1000)
          this.stopAutoProgress()
          return
        }
        
        const delay = currentStepId === 'main-graph' ? 3000 : 1000
        this.autoProgressTimer = setTimeout(progressNext, delay)
      }
      
      this.autoProgressTimer = setTimeout(progressNext, 1000)
    },
    
    stopAutoProgress () {
      if (this.autoProgressTimer) {
        clearTimeout(this.autoProgressTimer)
        this.autoProgressTimer = null
      }
    },
    
    showBubbleJumpConfirm () {
      this.$confirm('是否跳转到气泡图？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // 用户确认跳转
        this.jumpToBubblePage()
      }).catch(() => {
        // 用户取消，不做任何处理
        this.$store.dispatch('processFlow/setWaitingForBubbleJump', false)
      })
    },
    
    jumpToBubblePage () {
      // 先推进到下一步（从秒记库到标签主体化）
      this.$store.dispatch('processFlow/nextStep')
      
      // 跳转到气泡图页面
      this.$router.push({
        name: 'bubble',
        query: {
          fromDraft: true, // 标记从白板跳转过来
          source: 'flow' // 标记从流程跳转
        }
      })
      
      // 继续流程
      this.$store.dispatch('processFlow/resumeFlow')
      
      // 重新启动自动进度（在气泡图页面继续流程）
      setTimeout(() => {
        this.startAutoProgress()
      }, 500)
    }
  },

  created () {
    this.$watch('$route.query', (newQuery) => {
      this.draftId = newQuery.id
    })
  },

  mounted () {
    this.draftId = this.$route.query.id
    const userId = this.$route.query.userId
    const userinfo = JSON.parse(localStorage.getItem('userinfo'))
    if (!userinfo) {
      return
    }
    
    if (userId && userId !== userinfo?.userId) {
      this.$confirm('有用户给你分享了一篇白板，是否接受该白板', '提示', {
        confirmButtonText: '接受',
        cancelButtonText: '不接受',
        type: 'warning'
      }).then(() => {
        // 说明是别人分享给我的
        request('/api/Draft/draftShare', {
          draft_id: this.draftId,
          member_ids: userinfo.userid.toString()
        }).then((res) => {
          this.dialogTableVisible = false
        }).catch((err) => {
          this.$message.error(err.message)
        })
      })
    }
    
    this.$nextTick(() => {
      const currentStep = this.currentRunningStep
      if (currentStep && currentStep.id === 'main-graph') {
        this.startAutoProgress()
      }
    })
  },
  
  beforeDestroy () {
    this.stopAutoProgress()
  }
}
</script>
<style lang="scss" scoped>

.login-container{
  text-align: center;
  h3{
    font-size: 16px;
    margin-bottom: 20px;
    color: #000;
  }
  :deep(.register){
    width: auto;
    height: auto;
    padding-top: 0;
  }
}

// 流程进度触发图标样式
.flow-trigger-icon {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1500;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  
  i {
    font-size: 26px;
    color: white;
    z-index: 2;
  }

  // 脉冲动画背景
  .icon-pulse {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    animation: pulse-ring 2s cubic-bezier(0.25, 0.8, 0.25, 1) infinite;
  }

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 30px rgba(102, 126, 234, 0.6);
    
    i {
      animation: icon-rotate 0.6s ease;
    }
  }

  &:active {
    transform: scale(0.95);
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.4;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

@keyframes icon-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
